import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { StyleProps } from 'src/model'

export const SideBarLabelD2 = styled.span`
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    font-size: 1.4rem;
    color: #667085;
    font-weight: 400
`
export const SideBarIconsD2 = styled.div<StyleProps>`
    display: grid;
    place-items: center;
    width: auto;
    height: auto;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
`